
import './App.css';

import About from './components/About';
import Navbar from './components/Navbar';
 import TextForm from './components/TextForm'; 
 import Alert from './components/Alert';
 import React, { useState } from 'react';
 

 import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";


function App() {
  const [mode,setMode]=useState('light'); // whether darkmode mode is enabled or not 
  const [alert,setAlert]=useState(null);

  const showAlert = (message,type)=>{
    setAlert({
      msg:message,
      type:type
    })
    setTimeout(()=>{
          setAlert(null);
    },1000)

  }

  


const toggleMode = ()=>{
  if(mode === 'light'){
    setMode('dark');
    document.body.style.backgroundColor = '#042743';
    showAlert("Dark mode has been enabled", "success");
    // document.title = 'TextUtils - Dark Mode';
    // setInterval(() => {
    //   document.title = 'TextUtils is Amazing Mode';
    // }, 2000);
    // setInterval(() => {
    //   document.title = 'Install TextUtils Now';
    // }, 1500);
  }
  else{
    setMode('light');
    document.body.style.backgroundColor = 'white';
    showAlert("Light mode has been enabled", "success");
    // document.title = 'TextUtils - Light Mode';
  }
}
  return (
    <>
    <Router>
     <Navbar title={"Textutils (Text Analysis Tool)"} aboutText={"About"} mode={mode}  toggleMode={toggleMode}/>
     <Alert alert={alert}/>
     <div className="container my-3" >
     <Switch>
          <Route exact path="/about">
            <About mode={mode}/>
          </Route>
          <Route exact path="/">
           <TextForm showAlert={showAlert} heading={"Try TextUtils - Word Counter, Character Counter,Remove Extra Spaces"} mode={mode}/>
          </Route>
    </Switch>

        </div>
     </Router>
    </>
  
  );
}

export default App;
